export default "__VITE_ASSET__IfvPISR4__"